import { Body, ContainerLogo, ContainerMain, Header } from './style';
import { ZennexuLogo } from '../../assets';
import { ButtonForm, ProgressSteps } from '../../components';
import { Step1Props } from './types';

export default function Step1(props: Step1Props) {
  const { onClick, step } = props;
  return (
    <ContainerMain>
      <ContainerLogo>
        <img src={ZennexuLogo} alt="logo" />
      </ContainerLogo>
      <Header>
        <div className="info">
          <p>Seu Carro Novo Sem Entrada - Não importa se é negativado</p>
          <span>
            Aprovação em minutos, mesmo para negativados Sem entrada e zero
            complicações
          </span>
        </div>
        <div className="progress">
          <ProgressSteps currentStep={step} totalSteps={2} />
          <h1>Qual é a faixa de preço do carro que você deseja comprar?</h1>
        </div>
      </Header>
      <Body>
        <ButtonForm
          title="R$ 35.000 a R$ 45.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm
          title="R$ 45.000 a R$ 55.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm
          title="R$ 55.000 a R$ 65.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm title="Acima de R$ 65.000" isOutlined onClick={onClick} />
      </Body>
    </ContainerMain>
  );
}
